import { AppointmentType } from '@generated/gql/graphql';
import { useTrackingContext } from '@tracking/Provider/Context';
import { useTrackSignupStartPartnerAppointmentClickedOnce } from '@tracking/trackingEvents';

import { GETTING_QUOTE, PartnerFormValues, SUPPORT_REMOTE } from './types';

type AppointmentTypeTracking =
  | 'face_to_face'
  | 'partner_remote'
  | 'support_remote'
  | 'getting_quote';

const mapAppointmentTypeForTracking = (
  values: PartnerFormValues
): AppointmentTypeTracking => {
  switch (values.appointmentType) {
    case AppointmentType.FaceToFace:
    case AppointmentType.FaceToFaceWithRemoteSupport:
      return 'face_to_face';

    case AppointmentType.PartnerRemote:
      return 'partner_remote';

    case SUPPORT_REMOTE:
      return 'support_remote';

    case GETTING_QUOTE:
      return 'getting_quote';
    default:
      throw new Error(`Unsupported appointmentType: ${values.appointmentType}`);
  }
};

const useStartPartnerAppointmentFormTracking = () => {
  const { trackingContexts } = useTrackingContext();

  const trackOnce = useTrackSignupStartPartnerAppointmentClickedOnce();

  const trackStartPartnerAppointmentClicked = (values: PartnerFormValues) => {
    trackOnce(
      {
        appointment_type: mapAppointmentTypeForTracking(values),
      },
      { contexts: trackingContexts }
    );
  };
  return { trackStartPartnerAppointmentClicked };
};

export { useStartPartnerAppointmentFormTracking };
